import templateUrl from './timeclockMapPopupComponent.html';

export default {
  templateUrl,
  bindings: {
    locationId: '<',
    clockInCoordinates: '<?',
    clockOutCoordinates: '<?',
  },
  controllerAs: 'ctrl',
  controller: class {
    constructor(Authentication, PersonaCollection, GoogleMapsService, TimesheetsService) {
      'ngInject';

      Object.assign(this, {
        Authentication,
        PersonaCollection,
        GoogleMapsService,
        TimesheetsService,
      });
    }

    $onInit() {
      this.location = this.PersonaCollection.personasDict[this.locationId];
      this.pinRadiusMeters = this.TimesheetsService.getTimeclockRadiusInMeters();
    }
  },
};
